import React from 'react';
import PropTypes from 'prop-types';

import AddClaimButton from '../AddClaimButton';

export default function NoData({ isPossibleAddClaim }) {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <h2>You have no open claims.</h2>

      <div className="mb-4">Click the button to file a claim.</div>

      <AddClaimButton isPossibleAddClaim={isPossibleAddClaim} />
    </div>
  );
}

NoData.propTypes = {
  isPossibleAddClaim: PropTypes.bool,
};

NoData.defaultProps = {
  isPossibleAddClaim: false,
};
